import React, { useState } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import HomeScreen from './screens/Home'
// import AboutScreen from './screens/AboutUsScreen'
import ProjectsScreen from './screens/ProjectsScreen'
import ContactScreen from './screens/ContactScreen'
import LoginScreen from './screens/LoginScreen'
import ManageProjects from './screens/ManageProjects'
import withAdminAuth from './hooks/withAdminAuth'
import ProjectDetailScreen from './screens/ProjectDetailScreen'
import './assets/css/App.css'
import AddProjects from './screens/AddProjects'
import EditProject from './screens/EditProject'
import ArchitectureScreen from './screens/ArchitectureScreen'
import InteriorScreen from './screens/InteriorScreen'
import Constructioncreen from './screens/ConstructionScreen'   

const ProtectedManageProjects = withAdminAuth(ManageProjects)

function App () {
  const [language, setLanguage] = useState('en')

  const onLanguageChange = lang => {
    setLanguage(lang)
  }

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div className='App'>
        <div className='Navbar'>
          <Navbar language={language} onLanguageChange={onLanguageChange} />
        </div>
        <div className='Content'>
          <Routes>
            <Route path='/home' element={<HomeScreen language={language} />} />
            {/* <Route
              path='/about'
              element={<AboutScreen language={language} />}
            /> */}
            <Route
              path='/projects'
              element={<ProjectsScreen language={language} />}
            />
            <Route
              path='/projects/:projectId'
              element={<ProjectDetailScreen />}
            />
            <Route
              path='/contact'
              element={<ContactScreen language={language} />}
            />
            <Route
              path='/login'
              element={<LoginScreen language={language} />}
            />
            <Route
              path='/manageprojects'
              element={<ProtectedManageProjects language={language} />}
            />
            <Route path='addprojects' element={<AddProjects />} />
            <Route path='/' element={<HomeScreen language={language} />} />
            <Route path='edit-project/:id' element={<EditProject />} />
            <Route path='projects/ArchitectureScreen' element={<ArchitectureScreen language={language} />} />
            <Route path='projects/InteriorScreen' element={<InteriorScreen language={language} />} />
            <Route path='projects/Constructioncreen' element={<Constructioncreen language={language} />} />
          </Routes>
        </div>
        <div className='footer'>
          <Footer language={language} />
        </div>
      </div>
    </Router>
  )
}

export default App
